import React, { useState } from 'react';
import { CssBaseline, Box, Typography, Input, Button, Card, Grid } from '@mui/joy';

const CalculadoraPage = () => {
    const [price, setPrice] = useState('');
    const [weight, setWeight] = useState(1); // Valor padrão 1
    const [results, setResults] = useState({
        amazon: 0,
        enjoei: 0
    });
    const [retorno, setRetorno] = useState(0);
    const [precoRetorno, setPrecoRetorno] = useState(0);

    const calculateFees = () => {
        const priceValue = parseFloat(price) || 0;
        const amazonFee = priceValue * 0.85;
        const enjoeiFee = priceValue * 0.88;

        setResults({
            amazon: amazonFee.toFixed(2),
            enjoei: enjoeiFee.toFixed(2),
        });
    };

    var enjoeiRetorno = calculaPrecoFinalEnjoeiDadoRetorno(retorno, precoRetorno)
    var enjoeiRetornoTurbo = calculaPrecoFinalEnjoeiTurboDadoRetorno(retorno, precoRetorno)
    var liquidoEnjoei = (price * 0.88 - tarifaEnjoei(price, weight)).toFixed(2);
    var liquidoEnjoeiTurbo = (price * 0.82 - tarifaEnjoeiTurbo(price, weight)).toFixed(2)
    var liquidoAmazon = (price * 0.85 - taxaFixaAmazon(price, weight))
    
    return (
        <Grid container>
            <Grid xs={12}>
                <Box
                    sx={{
                        padding: '2rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '2rem',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '2rem',
                            justifyContent: 'center',
                        }}
                    ><CssBaseline />
                        <Card
                            variant="outlined"
                            sx={{
                                padding: '2rem',
                                width: '100%',
                                maxWidth: '400px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '1rem',
                            }}
                        >
                            <Typography level="h6">Calculadora Liquido</Typography>
                            <Input
                                type="text"
                                placeholder="Preço"
                                value={price}
                                onChange={(e) => {
                                    setPrice((e.target.value
                                        .replace(/,/g, '.'))
                                        .replace(/[^0-9.]/g, ''))
                                }}
                            />
                            <Input
                                type="number"
                                placeholder="Peso (kg)"
                                value={weight}
                                onChange={(e) => setWeight(e.target.value)}
                                defaultValue={1}
                            />
                        </Card>
                        <Card variant="soft" sx={{ padding: '1rem', minWidth: '250px' }}>
                            <Typography level="h6">Amazon</Typography>
                            <Typography>Preço: R$ {price}</Typography>
                            <Typography>Comissão: R$ {((price) * 0.15).toFixed(2)}</Typography>
                            <Typography>Taxa Fixa: R$ {(taxaFixaAmazon(price, weight)).toFixed(2)}</Typography>
                            <Typography>Liquido: R$ {liquidoAmazon.toFixed(2)}</Typography>
                            <Typography>ML : {(100*liquidoAmazon/price).toFixed(2)}%</Typography>
                        </Card>
                        <Card variant="soft" sx={{ padding: '1rem', minWidth: '250px' }}>
                            <Typography level="h6">Enjoei Clássico</Typography>
                            <Typography>Preço: R$ {price}</Typography>
                            <Typography>Comissão (Clas.): R$ {((price) * 0.12).toFixed(2)}</Typography>
                            <Typography>Taxa Fixa: R$ {(tarifaEnjoei(price, weight)).toFixed(2)}</Typography>
                            <Typography>Liquido: R$ {liquidoEnjoei}</Typography>
                            <Typography>ML : {(100*liquidoEnjoei/price).toFixed(2)}%</Typography>
                        </Card>
                        <Card variant="soft" sx={{ padding: '1rem', minWidth: '250px' }}>
                            <Typography level="h6">Enjoei Turbo:</Typography>
                            <Typography>Preço: R$ {price}</Typography>
                            <Typography>Comissão (Clas.): R$ {((price) * 0.18).toFixed(2)}</Typography>
                            <Typography>Taxa Fixa: R$ {(tarifaEnjoeiTurbo(price, weight)).toFixed(2)}</Typography>
                            <Typography>Liquido: R$ {(price * 0.82 - tarifaEnjoeiTurbo(price, weight)).toFixed(2)}</Typography>
                            <Typography>ML : {(100*liquidoEnjoeiTurbo/price).toFixed(2)}%</Typography>
                        </Card>
                    </Box>
                </Box>
            </Grid>
            <Grid xs={12}>
                <Box
                    sx={{
                        padding: '2rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '2rem',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '2rem',
                            justifyContent: 'center',
                        }}
                    ><CssBaseline />
                        <Card
                            variant="outlined"
                            sx={{
                                padding: '2rem',
                                width: '100%',
                                maxWidth: '400px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '1rem',
                            }}
                        >
                            <Typography level="h6">Retorno</Typography>
                            <Input
                                type="text"
                                placeholder="Retorno %"
                                value={retorno}
                                onChange={(e) => {
                                    setRetorno((e.target.value
                                        .replace(/,/g, '.'))
                                        .replace(/[^0-9.]/g, ''))
                                }}
                            />
                            <Input
                                type="text"
                                placeholder="Preço"
                                value={precoRetorno}
                                onChange={(e) => {
                                    setPrecoRetorno((e.target.value
                                        .replace(/,/g, '.'))
                                        .replace(/[^0-9.]/g, ''))
                                }}
                            />
                            <Input
                                type="number"
                                placeholder="Peso (kg)"
                                value={weight}
                                onChange={(e) => setWeight(e.target.value)}
                                defaultValue={1}
                            />
                        </Card>
                        <Card variant="soft" sx={{ padding: '1rem', minWidth: '250px' }}>
                            <Typography level="h6">Amazon</Typography>
                            <Typography>Retorno: R$ {(precoRetorno * (retorno / 100 + 1)).toFixed(2)}</Typography>
                            <Typography>Preço: R$ {precoFinalDadoRetorno(retorno, precoRetorno, weight).toFixed(2)}</Typography>
                            <Typography>Comissão: R$ {((precoFinalDadoRetorno(retorno, precoRetorno, weight)) * 0.15).toFixed(2)}</Typography>
                            <Typography>Taxa Fixa: R$ {(taxaFixaAmazon(precoFinalDadoRetorno(retorno, precoRetorno, weight), weight)).toFixed(2)}</Typography>
                            <Typography>Liquido: R$ {(precoFinalDadoRetorno(retorno, precoRetorno, weight) * 0.85 - taxaFixaAmazon(precoFinalDadoRetorno(retorno, precoRetorno, weight), weight)).toFixed(2)}</Typography>
                        </Card>

                        <Card variant="soft" sx={{ padding: '1rem', minWidth: '250px' }}>
                            <Typography level="h6">Enjoei</Typography>
                            <Typography>Retorno: R$ {(precoRetorno * (retorno / 100 + 1)).toFixed(2)}</Typography>
                            <Typography>Preço: R$ {enjoeiRetorno.precoFinal.toFixed(2)}</Typography>
                            <Typography>Comissão: R$ {(enjoeiRetorno.comissao).toFixed(2)}</Typography>
                            <Typography>Taxa Fixa: R$ {enjoeiRetorno.tarifa.toFixed(2)}</Typography>
                            <Typography>Liquido: R$ {enjoeiRetorno.liquido.toFixed(2)}</Typography>
                        </Card>

                        <Card variant="soft" sx={{ padding: '1rem', minWidth: '250px' }}>
                            <Typography level="h6">Enjoei Turbo</Typography>
                            <Typography>Retorno: R$ {(precoRetorno * (retorno / 100 + 1)).toFixed(2)}</Typography>
                            <Typography>Preço: R$ {enjoeiRetornoTurbo.precoFinal.toFixed(2)}</Typography>
                            <Typography>Comissão: R$ {(enjoeiRetornoTurbo.comissao).toFixed(2)}</Typography>
                            <Typography>Taxa Fixa: R$ {enjoeiRetornoTurbo.tarifa.toFixed(2)}</Typography>
                            <Typography>Liquido: R$ {enjoeiRetornoTurbo.liquido.toFixed(2)}</Typography>
                        </Card>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

function calculaPrecoFinalEnjoeiDadoRetorno(taxaRetorno, precoCusto) {

    if (taxaRetorno < 1) taxaRetorno = 1
    if (precoCusto < 1) precoCusto = 1

    var taxaEnjoei = 0.12
    var taxaLiquida = 1 - taxaEnjoei

    var retornoLiquidoPretendido = precoCusto * (1 + (taxaRetorno / 100))
    var precoFinal = retornoLiquidoPretendido / taxaLiquida
    var liquido = (precoFinal * taxaLiquida) - tarifaEnjoei(precoFinal)
    while (liquido < retornoLiquidoPretendido) {
        precoFinal += 0.1
        liquido = (precoFinal * taxaLiquida) - tarifaEnjoei(precoFinal)
    }

    return {
        tarifa: tarifaEnjoei(precoFinal),
        precoFinal: precoFinal,
        liquido: liquido,
        comissao : precoFinal * taxaEnjoei
    }

}

function calculaPrecoFinalEnjoeiTurboDadoRetorno(taxaRetorno, precoCusto) {

    if (taxaRetorno < 1) taxaRetorno = 1
    if (precoCusto < 1) precoCusto = 1

    var taxaEnjoei = 0.18
    var taxaLiquida =  1 - taxaEnjoei

    var retornoLiquidoPretendido = precoCusto * (1 + (taxaRetorno / 100))
    var precoFinal = retornoLiquidoPretendido / taxaLiquida
    var liquido = (precoFinal * taxaLiquida) - tarifaEnjoeiTurbo(precoFinal)
    while (liquido < retornoLiquidoPretendido) {
        precoFinal += 0.1
        liquido = (precoFinal * taxaLiquida) - tarifaEnjoeiTurbo(precoFinal)
    }

    return {
        tarifa: tarifaEnjoeiTurbo(precoFinal),
        precoFinal: precoFinal,
        liquido: liquido,
        comissao : precoFinal * taxaEnjoei
    }

}

function precoFinalDadoRetornoEnjoei(retorno, preco, weight) {
    var liquido = (preco * (retorno / 100 + 1));
    return ((liquido) + tarifaEnjoei(liquido, weight)) / 0.88
}

function precoFinalDadoRetorno(retorno, preco, weight) {
    var liquido = (preco * ((retorno / 100) + 1));
    return (liquido + taxaFixaAmazon(liquido, weight)) / 0.85
}
function tarifaEnjoeiTurbo(preco, peso) {
    /*antiga 2024 
     if (preco < 15) {
        return 1.75
    } else if (preco < 30) {
        return 3.75
    } else if (preco < 50) {
        return 4.25
    } else if (preco < 70) {
        return 5.25
    } else if (preco < 100) {
        return 6.25
    } else if (preco < 150) {
        return 8.25
    } else if (preco < 300) {
        return 13.75
    } else if (preco < 500) {
        return 22.5
    } else {
        return 25
    }*/
    if (preco < 15) {
        return 3.5 //1.75
    } else if (preco < 30) {
        return 7.5 // 3.75
    } else if (preco < 50) {
        return 8.5 // 4.25
    } else if (preco < 70) {
        return 10.5 // 5.25
    } else if (preco < 100) {
        return 12.5 // 6.25
    } else if (preco < 150) {
        return 16.5 // 8.25
    } else if (preco < 300) {
        return 27.5 // 13.75
    } else if (preco < 500) {
        return 45 // 22.5
    } else {
        return 50 // 25
    }
}

function tarifaEnjoei(preco, peso) {
    /*antiga 2024 
     if (preco < 15) {
        return 1.75
    } else if (preco < 30) {
        return 3.75
    } else if (preco < 50) {
        return 4.25
    } else if (preco < 70) {
        return 5.25
    } else if (preco < 100) {
        return 6.25
    } else if (preco < 150) {
        return 8.25
    } else if (preco < 300) {
        return 13.75
    } else if (preco < 500) {
        return 22.5
    } else {
        return 25
    }*/
    if (preco < 15) {
        return 2.5 //1.75
    } else if (preco < 30) {
        return 6 // 3.75
    } else if (preco < 50) {
        return 6.5 // 4.25
    } else if (preco < 70) {
        return 8 // 5.25
    } else if (preco < 100) {
        return 10 // 6.25
    } else if (preco < 150) {
        return 12.5 // 8.25
    } else if (preco < 300) {
        return 21.5 // 13.75
    } else if (preco < 500) {
        return 35 // 22.5
    } else {
        return 40 // 25
    }
}

function taxaFixaAmazon(preco, peso) {
    if (preco < 79) {
        return preco < 30 ? 4.50 : 8.00;
    }

    const tarifas = [
        { limitePeso: 0.25, valor: 20.45 },
        { limitePeso: 0.5, valor: 20.95 },
        { limitePeso: 1, valor: 21.95 },
        { limitePeso: 2, valor: 23.45 },
        { limitePeso: 3, valor: 24.45 },
        { limitePeso: 4, valor: 25.95 },
        { limitePeso: 5, valor: 27.95 },
        { limitePeso: 6, valor: 36.95 },
        { limitePeso: 7, valor: 39.45 },
        { limitePeso: 8, valor: 40.45 },
        { limitePeso: 9, valor: 46.95 },
        { limitePeso: 10, valor: 65.95 },
    ]

    for (const faixa of tarifas) {
        if (peso <= faixa.limitePeso) {
            return faixa.valor;
        }
    }

    const pesoExcedente = peso - 10;
    const tarifaBase = tarifas[tarifas.length - 1].valor;
    return tarifaBase + Math.ceil(pesoExcedente) * 4.00;
}


export default CalculadoraPage;
